import { Component, OnInit } from '@angular/core';
import {EsBsModalService} from "../../services/bsModalService/bs-modal.service";

@Component({
  selector: 'app-object-array-confirm-modal',
  templateUrl: './object-array-confirm-modal.component.html',
  styleUrls: ['./object-array-confirm-modal.component.scss']
})
export class ObjectArrayConfirmModalComponent {

  public Yiit = Yiit;
  public modalMessage = Yiit.t('Do you want to delete whole array?');

  constructor(private bs: EsBsModalService) { }

  sendConfirmation(resultMessage){
    this.bs.modalEventFire$ = {removeConfirmationMessage: resultMessage};
  }

}
